import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

const unwrap = (res) => res.data;

export const aMAnalyticsApi = createApi({
  reducerPath: 'aMAnalyticsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['analytics'],
  endpoints: builder => ({
    // Campaign overview
    getCampaignOverview: builder.query({
      query: (params) => ({ url: '/analytics/campaign-overview/', params }),
      transformResponse: unwrap,
      providesTags: ['analytics'],
    }),
    // Summary stats
    getReportedRemoved: builder.query({
      query: (params) => ({ url: '/analytics/reported-removed/', params }),
      transformResponse: unwrap,
      providesTags: ['analytics'],
    }),
    getDailyMonthlyStatistics: builder.query({
      query: (params) => ({ url: '/analytics/daily-monthly-statistics', params }),
      transformResponse: unwrap,
      providesTags: ['analytics'],
    }),
    getTodayThisMonthRemovals: builder.query({
      query: (params) => ({ url: '/analytics/today-this-month-removals/', params }),
      transformResponse: unwrap,
      providesTags: ['analytics'],
    }),
    // Per breakdown
    getPerCustomerReportedRemoved: builder.query({
      query: (params) => ({ url: '/analytics/per-customer-reported-removed/', params }),
      transformResponse: unwrap,
      providesTags: ['analytics'],
    }),
    getPerServiceMonthReportedRemoved: builder.query({
      query: (params) => ({ url: '/analytics/per-service-month-reported-removed/', params }),
      transformResponse: unwrap,
      providesTags: ['analytics'],
    }),
    getPerServiceReported: builder.query({
      query: (params) => ({ url: '/analytics/per-service-reported/', params }),
      transformResponse: unwrap,
      providesTags: ['analytics'],
    }),
    getTopRemovalPerCampaignService: builder.query({
      query: (params) => ({ url: '/analytics/top-removal-per-campaign-service', params }),
      transformResponse: unwrap,
      providesTags: ['analytics'],
    }),
    // Charts
    getDailyReportedRemoved: builder.query({
      query: (params) => ({ url: '/analytics/daily-reported-removed/', params }),
      transformResponse: unwrap,
      providesTags: ['analytics'],
    }),
    getPerServiceMonthlyDetailed: builder.query({
      query: (params) => ({ url: '/analytics/per-service-monthly-detailed/', params }),
      transformResponse: unwrap,
      providesTags: ['analytics'],
    }),
    // Top lists
    getTopCampaigns: builder.query({
      query: (params) => ({ url: '/analytics/top-campaigns/', params }),
      transformResponse: unwrap,
      providesTags: ['analytics'],
    }),
    getTopRemovalsServices: builder.query({
      query: (params) => ({ url: '/analytics/top-removals-services/', params }),
      transformResponse: unwrap,
      providesTags: ['analytics'],
    }),
    getTopPiratedDomains: builder.query({
      query: (params) => ({ url: '/analytics/top-pirated-domains/', params }),
      transformResponse: unwrap,
      providesTags: ['analytics'],
    }),
    getTopMaintainers: builder.query({
      query: (params) => ({ url: '/analytics/top-maintainers/', params }),
      transformResponse: unwrap,
      providesTags: ['analytics'],
    }),
  }),
});

export const {
  useGetCampaignOverviewQuery,
  useGetReportedRemovedQuery,
  useGetDailyMonthlyStatisticsQuery,
  useGetTodayThisMonthRemovalsQuery,
  useGetPerCustomerReportedRemovedQuery,
  useGetPerServiceMonthReportedRemovedQuery,
  useGetPerServiceReportedQuery,
  useGetTopRemovalPerCampaignServiceQuery,
  useGetDailyReportedRemovedQuery,
  useGetPerServiceMonthlyDetailedQuery,
  useGetTopCampaignsQuery,
  useGetTopRemovalsServicesQuery,
  useGetTopPiratedDomainsQuery,
  useGetTopMaintainersQuery,
} = aMAnalyticsApi;
